
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromStore from '../store';
import * as SetScreenActions from '../store/actions/screen.actions';
import { fromEvent } from 'rxjs';
import { debounceTime, map, distinctUntilChanged, startWith, tap } from 'rxjs/operators';
import { MOBILE_MAX_WIDTH } from '@ibe/store/reducers/screen.reducer';

@Injectable()
export class ScreenService {
	mobile$ = this.store.select(state => state.screen.mobile);
	tabletPortrait$ = this.store.select(state => state.screen.tabletPortrait);
	mobileTabletPortrait$ = this.store.select(state => state.screen.mobileTabletPortrait);
	tabletLandscape$ = this.store.select(state => state.screen.tabletLandscape);
	desktop$ = this.store.select(state => state.screen.desktop);

	constructor(private store: Store<fromStore.State>) {
	}

	setWindowWidth(windowWidth: number): void {
		this.store.dispatch(new SetScreenActions.SetScreen(windowWidth));
	}

	isMobile() {
		return fromEvent(window, 'resize')
				.pipe(
					debounceTime(250),
					map(() => window.innerWidth < MOBILE_MAX_WIDTH),
					distinctUntilChanged(),
					startWith(window.innerWidth < MOBILE_MAX_WIDTH),
				);
	}
}
